module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAGUlEQVQoU2P8////fwYiAOOoQnyhRP3gAQDBjyfjZWEr1QAAAABJRU5ErkJggg=="